<div class="conversion-dialog">
<button mat-icon-button class="close-button" [mat-dialog-close]="null">
  <mat-icon>close</mat-icon>
</button>

<h2 class="mat-dialog-title" mat-dialog-title>Transaction Pending</h2>

<mat-dialog-content>
  <p>Your Bank transfer is pending. Please enter the Payment Details after completing your bank transfer.</p>
</mat-dialog-content>

<mat-dialog-actions class="action-btn" align="end">
  <button class="submit-btn" mat-raised-button color="primary" [mat-dialog-close]="'redirect'">
    Go to Transactions
  </button>
</mat-dialog-actions>
</div>
